import { connect } from 'react-redux';
import CommentUserBanner from './CommentUserBanner';
import deleteComment from '../../../../../core/actions/comment/deleteComment';
import { currentUserId as getCurrentUserId } from '../../../../../core/selectors/user';
import { accessingCurrentSpaceAsStaff } from '../../../../../core/selectors/classroom';
import { isInstructor } from '../../../../utils/user';

const mapStateToProps = (state, ownProps) => {
  const currentUserId = getCurrentUserId(state);
  return {
    isEducator: isInstructor(currentUserId),
    isAuthor: currentUserId === ownProps.comment.author,
    isReadOnlyUser: accessingCurrentSpaceAsStaff(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleDelete: () => {
    dispatch(deleteComment(ownProps.comment.id));
  },
});

const CommentUserBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CommentUserBanner);

export default CommentUserBannerContainer;
